import { Theme } from "@mui/material/styles";

import { getAccordionComponents } from "./accordion";
import { getButtonsComponents } from "./buttons";
import { getCheckboxComponents } from "./checkbox";
import { getChipComponents } from "./chip";
import { getDialogsComponents } from "./dialogs";
import { getInputComponents } from "./input";
import { getPopoverComponents } from "./popover";
import { getSnackbarComponents } from "./snackbar";
import { getSwitcherComponents } from "./switcher";
import { getTableComponents } from "./table";
import { getTabsComponents } from "./tabs";
import { getTooltipComponents } from "./tooltip";
import { getTypographyComponents } from "./typography";

export const getSunoComponents = (sunoTheme: Theme) => ({
  ...getButtonsComponents(sunoTheme),
  ...getTableComponents(sunoTheme),
  ...getTabsComponents(sunoTheme),
  ...getDialogsComponents(sunoTheme),
  ...getInputComponents(sunoTheme),
  ...getCheckboxComponents(sunoTheme),
  ...getTypographyComponents(sunoTheme),
  ...getAccordionComponents(sunoTheme),
  ...getPopoverComponents(sunoTheme),
  ...getSwitcherComponents(sunoTheme),
  ...getSnackbarComponents(sunoTheme),
  ...getChipComponents(sunoTheme),
  ...getTooltipComponents(sunoTheme)
});
